import styled from 'styled-components'
import cross from '../../assets/addStockModal/pages/cross.svg'
import check from '../../assets/addStockModal/pages/check.svg'
import arrowDown from '../../assets/certificates/AddParameter/arrow-down.svg'

export const Container = styled.div`
    position: absolute;
    width: 40rem;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 9004;
    padding: 20px;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
    color: #303030;
`

export const MachineDiv = styled.div`
    display: grid;
    margin-top: 3vh;
`
export const OPDiv = styled.div`
    display: grid;
    margin-top: 3vh;
`

export const InfoText = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #303030;
    margin-bottom: 0.5vh;
`

export const Select = styled.select`
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #EBEBEB;
`

export const ActionsDiv = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 2rem 0;
    gap: 16px;
`
export const CancelButton = styled.button`
    width: 8rem;
    height: 2.5rem;
    border-radius: 20px;
    border: 1px solid #0090D3;
    background-color: #FFFFFF;
    color: #0090D3;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

export const AddOPS = styled.button`
    width: 11rem;
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #0090D3;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

 export const SelectedOPContainer = styled.div`
     display: flex;
     flex-wrap: wrap;
     gap: 8px;
     margin-top: 10px;
     padding: 5px;
     border: 1px solid #e0e0e0;
     border-radius: 4px;
     min-height: 40px;
     align-items: center;
 `;
 export const SelectedOPTag = styled.div`
     display: flex;
     align-items: center;
     background-color: #e0e0e0;
     padding: 5px 10px;
     border-radius: 20px;
     font-size: 0.9em;
     cursor: default;
 `;
 export const RemoveTagButton = styled.button`
     background: none;
     border: none;
     color: #555;
     font-weight: bold;
     margin-left: 8px;
     cursor: pointer;
     &:hover {
         color: #000;
     }
 `;